import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import {
  NEW_CERTIFICATE_DESIGNS,
  PRICE_PRESETS,
  SHIPPING_TYPES,
} from './constants';

export interface CertificateState {
  value: number;
  design: string;
  holder: null | string;
  text: null | string;
  shippingType: string;
  link: string | null;
}

const initialState = {
  value: PRICE_PRESETS[0],
  design: Object.values(NEW_CERTIFICATE_DESIGNS)[2],
  holder: null,
  text: null,
  shippingType: SHIPPING_TYPES[0].value,
  link: null,
} as CertificateState;

const certificateSlice = createSlice({
  name: 'certificate',
  initialState,
  reducers: {
    setCertHolder(state, action: PayloadAction<CertificateState['holder']>) {
      state.holder = action.payload;
    },
    setCertDesign(state, action: PayloadAction<CertificateState['design']>) {
      state.design = action.payload;
    },
    setCertText(state, action: PayloadAction<CertificateState['text']>) {
      state.text = action.payload;
    },
    setCertShippingType(
      state,
      action: PayloadAction<CertificateState['shippingType']>,
    ) {
      state.shippingType = action.payload;
    },
    downloadCertificateSuccess(
      state,
      action: PayloadAction<CertificateState['link']>,
    ) {
      state.link = action.payload;
    },
  },
});

export const {
  setCertHolder,
  setCertDesign,
  setCertText,
  setCertShippingType,
  downloadCertificateSuccess,
} = certificateSlice.actions;

export const { name } = certificateSlice;
export default certificateSlice.reducer;
